const PRIORITY_BADGE_BY_LEVEL = {
  1: 'danger',
  2: 'primary',
  3: 'secondary',
};

export const getPriorityLabelByLevel = (level, language) => {
  if (level === 1) return 'Alta';
  if (level === 2) return 'Media';
  if (level === 3) return language === 'es' ? 'Baja' : 'Bassa';
  return '-';
};

export const parsePriorityLevel = (value) => {
  if (value === null || value === undefined) return null;
  const normalized = String(value).trim().toLowerCase();

  if (normalized === '1' || normalized === 'alta' || normalized === 'high') return 1;
  if (normalized === '2' || normalized === 'media' || normalized === 'medium') return 2;
  if (
    normalized === '3'
    || normalized === 'bassa'
    || normalized === 'baja'
    || normalized === 'low'
  ) {
    return 3;
  }

  return null;
};

const getPriorityDisplay = (dataItem, field = 'priorita', language = 'it') => {
  const sourceLanguage = language === 'es' ? 'es' : 'it';
  const rawValue = dataItem?.priority_id ?? dataItem?.priorita ?? dataItem?.[field];
  const priorityLevel = parsePriorityLevel(rawValue);

  if (!priorityLevel) {
    return {
      label: '-',
      badgeColor: 'secondary',
    };
  }

  return {
    label: getPriorityLabelByLevel(priorityLevel, sourceLanguage),
    badgeColor: PRIORITY_BADGE_BY_LEVEL[priorityLevel],
  };
};


/**
 * Uniforma la priorita' di una riga griglia all'etichetta (OSSQ-2383).
 *
 * <p>Il valore arriva in due forme: le SP CContact espongono l'etichetta
 * ('Alta'/'Media'/'Bassa'), ma os-bff in patchGridListaPrioritaIncarico
 * riscrive priority_id e priorita come INTERO 1 sulle righe incarico, e il
 * normalizzatore che li riconverte gira solo sul path paginato. Sulla lista
 * completa, che arriva dall'endpoint non paginato, i valori restano misti.
 *
 * <p>In griglia non si nota, perche' getPriorityDisplay accetta entrambe le
 * forme, ma filtro e ordinamento Kendo confrontano il valore vero e sulle
 * righe con l'intero non matchano: e' il motivo per cui il filtro priorita'
 * funzionava in "i miei task" e non in "tutti i task".
 *
 * <p>Il field della colonna, inoltre, e' configurato per utente in
 * grid_config_json e puo' essere 'priorita' o 'priority_id': si scrive quindi
 * su entrambi i nomi.
 */
export const normalizeTaskPriority = (task) => {
  if (!task || typeof task !== 'object') {
    return task;
  }
  const livello = parsePriorityLevel(task.priority_id ?? task.priorita);
  if (!livello) {
    return task;
  }
  const etichetta = getPriorityLabelByLevel(livello, 'it');
  if (task.priority_id === etichetta && task.priorita === etichetta) {
    return task;
  }
  return { ...task, priority_id: etichetta, priorita: etichetta };
};

export const normalizeTaskListPriority = (tasks) => (
  Array.isArray(tasks) ? tasks.map((task) => normalizeTaskPriority(task)) : tasks
);

export default getPriorityDisplay;

